// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__kasgO","subheader":"ReorderModal_subheader__2bZ1w","listWrap":"ReorderModal_listWrap__3yU0k"};